<div class="main-step-container">
  <div class="step-container" *ngFor="let step of steps; let i = index">
    <div
      mat-ripple
      class="step"
      [class.active]="i == currentStep"
      [class.disabled]="i > maxStep || (isStepperDisabled && i < currentStep)"
      (click)="onStepClick(i)"
    >
      <div class="index">
        {{ i + 1 }}
      </div>
      <div class="label">
        {{ step }}
      </div>
    </div>
  </div>
</div>
